import { render } from "./RetributionDetailsModal.vue?vue&type=template&id=3699c5e7"
import script from "./RetributionDetailsModal.vue?vue&type=script&lang=js"
export * from "./RetributionDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__